import React from "react";

interface Step {
  title: string;
}

interface StepProgressProps {
  steps: Step[];
  currentStep: number;
}

export const StepProgress: React.FC<StepProgressProps> = ({ steps, currentStep }) => (
  <div className="mb-8">
    <div className="flex items-center mb-8">
      {steps.map((step, index) => (
        <React.Fragment key={step.title}>
          <div 
            className={`flex items-center ${
              index === currentStep ? 'text-primary' : 'text-gray-500'
            }`}
          >
            <div className={`
              w-8 h-8 rounded-full flex items-center justify-center border-2
              ${index === currentStep ? 'border-primary bg-primary text-white' : 'border-gray-300'}
              ${index < currentStep ? 'bg-primary border-primary text-white' : ''}
            `}>
              {index + 1}
            </div>
            <span className="ml-2">{step.title}</span>
          </div>
          {index < steps.length - 1 && (
            <div className={`flex-1 h-0.5 mx-4 ${
              index < currentStep ? 'bg-primary' : 'bg-gray-300'
            }`} />
          )}
        </React.Fragment>
      ))}
    </div>
  </div>
);
